import cssClasses from "./SearchItem.module.css";

function SearchItem(props) {
  return (
    <div
      className={`${cssClasses.schTag} ${props.active ? cssClasses.schTagActive : ""}`}
      onClick={props.handleClick}
    >
      {props.category}
    </div>
  );
}

export default SearchItem;
